import z from 'zod';

export type Characteristic = 'Fluid' | 'SolidQuantifiable' | 'SolidNonQuantifiable';

export const CharacteristicSchema: z.ZodType<Characteristic> = z.enum([
	'Fluid',
	'SolidQuantifiable',
	'SolidNonQuantifiable',
]);
